/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, {Fragment, useState} from "react";
import {Link, NavLink as NavLinkRRD, useNavigate, useLocation} from "react-router";
import {
  Col,
  Collapse,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Media,
  NavbarToggler,
  NavLink,
  Row,
  UncontrolledDropdown,
} from "reactstrap";
import {FaBars, FaUserAlt} from "react-icons/fa";
import {useMediaQuery} from "react-responsive";
import logo from "../../assets/img/brand/brand-stacked-white.jpg";
import horizontalLogo from "../../assets/img/brand/ERP_logo_horizontal.png";
import {isDocumentationMode} from "../../constants/mode";
import {sideBarRoutes} from "../../routes";
import {logout} from "../../service/logout";
import NotificationMenu from "../Notification/NotificationMenu";
import "./sidebar.scss";

const Sidebar = () => {
  const [collapseOpen, setCollapseOpen] = useState(false);

  const isMobile = useMediaQuery({query: "(max-width: 659px)"});
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = () => {
    navigate("/auth/login");
    logout();
    window.location.reload();
  };

  const toggleCollapse = () => {
    setCollapseOpen(!collapseOpen);
  };

  const closeCollapse = () => {
    setCollapseOpen(false);
  };

  const createLinks = () => {
    return sideBarRoutes.map((route, key) => {
      const {icon: Icon, layout, name, path} = route;
      return (
        <NavLink
          to={layout + path}
          tag={NavLinkRRD}
          onClick={closeCollapse}
          className={`sidebar-option roboto-normal ${
            location.pathname === layout + path ? "active-sidebar" : ""
          }`}
          data-cy={`cy_${name.replace(" ", "-")}`}
          key={key}
        >
          <Icon className="sidebar-icon" />
          {name}
        </NavLink>
      );
    });
  };

  return (
    <Fragment>
      {!isMobile ? (
        <div
          id="sidenav-main"
          style={{
            position: isDocumentationMode ? "absolute" : "fixed",
          }}
        >
          <div className="sidebar-image-container">
            <img alt={"Logo"} className="sidebar-brand-img" src={logo} />
          </div>
          <div className="sidebar-route-container">{createLinks()}</div>
        </div>
      ) : (
        <Fragment>
          {!isDocumentationMode && (
            <div id="mobile-sidebar">
              <div className="mobile-sidebar-image-container">
                <img
                  alt={"Logo"}
                  className="mobile-sidebar-brand-img"
                  src={horizontalLogo}
                />
              </div>
              <div className="sidebar-notification-container">
                <NotificationMenu />
              </div>
              <div className="sidebar-profile-dropdown">
                <UncontrolledDropdown nav className="align-items-center profile">
                  <DropdownToggle data-cy={"sidebar-menu"} nav>
                    <Media className="align-items-center ">
                      <span
                        className="avatar avatar-sm rounded-circle"
                        style={{
                          border: "1px solid #00AFFF",
                        }}
                      >
                        <FaUserAlt />
                      </span>
                    </Media>
                  </DropdownToggle>
                  <DropdownMenu className="dropdown-menu-arrow" right>
                    <DropdownItem className="noti-title" header tag="div">
                      <h6 className="text-overflow m-0">Welcome!</h6>
                    </DropdownItem>
                    <DropdownItem
                      to="/app/profile"
                      tag={Link}
                      data-cy={"sidebar-profile"}
                    >
                      <i className="ni ni-single-02" />
                      <span>My profile</span>
                    </DropdownItem>
                    {/*
                    <DropdownItem to="/app/user-profile" tag={Link}>
                      <i className="ni ni-settings-gear-65" />
                      <span>Settings</span>
                    </DropdownItem>
                     */}
                    <DropdownItem
                      href="https://support.energyresourceproducts.com"
                      target="_blank"
                    >
                      <i className="ni ni-support-16" />
                      <span>Support</span>
                    </DropdownItem>
                    <DropdownItem>
                      <i className="ni ni-air-baloon" />
                      <span>v{import.meta.env.VITE_VERSION}</span>
                    </DropdownItem>
                    <DropdownItem divider />
                    <DropdownItem
                      href="#"
                      onClick={handleLogout}
                      data-cy={"sidebar-logout"}
                    >
                      <i className="ni ni-user-run" />
                      <span>Logout</span>
                    </DropdownItem>
                  </DropdownMenu>
                </UncontrolledDropdown>
              </div>
              <div
                className="collapse-toggler"
                id="navbar-collapse-main"
                onClick={toggleCollapse}
              >
                <FaBars className="mobile-sidebar-toggler-icon" size={24} />
              </div>
              <Collapse navbar isOpen={collapseOpen}>
                {/* Collapse header */}
                <div className="navbar-collapse-header d-md-none">
                  <Row>
                    <Col className="collapse-brand" xs="6">
                      <Link to={"/app/home"}>
                        <img alt={"Logo"} src={logo} />
                      </Link>
                    </Col>
                    <Col className="collapse-close" xs="6">
                      <NavbarToggler
                        className="navbar-toggler"
                        id="navbar-collapse-close"
                        onClick={toggleCollapse}
                      >
                        <span />
                        <span />
                      </NavbarToggler>
                    </Col>
                  </Row>
                </div>

                <div className="mobile-sidebar-route-container">{createLinks()}</div>
                {/* Divider */}
                <hr className="my-3" />
              </Collapse>
            </div>
          )}
        </Fragment>
      )}
    </Fragment>
  );
};

export default Sidebar;
